export const locale = {
    lang: 'en',
    data: {
        BACKGROUND_PANEL_CHOOSE:'Change background',
    }
};
